import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';

import { BcStateListContext } from '@bayclubs/state';

import moment from 'moment';
import { OnlineContentViewReportStateModel } from '../+state/online-content-view-report.state.model';
import { ReportsService } from '../services/reports.service';
import * as actions from './online-content-view-report.actions';

const initialState = {
    reportData: BcStateListContext.Empty(),
} as OnlineContentViewReportStateModel;

@Injectable({ providedIn: 'root' })
@State({
    name: 'onlineContentViewReport',
    defaults: initialState,
})
export class OnlineContentViewReportState {
    constructor(private reportsService: ReportsService) {}

    @Selector()
    static getReportData(state: OnlineContentViewReportStateModel) {
        return state.reportData;
    }

    @Action(actions.GenerateOnlineContentViewReportAction)
    generateOnlineContentViewReport(
        ctx: StateContext<OnlineContentViewReportStateModel>,
        action: actions.GenerateOnlineContentViewReportAction
    ) {
        return this.reportsService.generateOnlineContentViewReportFile(action.payload).subscribe(value => {
            this.downloadReportFile(value, 'online_content_view_');
        });
    }

    @Action(actions.LoadOnlineContentViewReportAction)
    loadOnlineContentViewReport(
        ctx: StateContext<OnlineContentViewReportStateModel>,
        action: actions.LoadOnlineContentViewReportAction
    ) {
        const state = ctx.getState();
        return this.reportsService.getOnlineContentViewReportData(action.payload).pipe(
            tap(value => {
                ctx.patchState({ reportData: BcStateListContext.Loaded(value.onlineContentViews) });
            })
        );
    }

    // TODO: Those two methods are common with other reports - it should be moved somewhere else
    private downloadReportFile(value: any, fileName: string) {
        const url = URL.createObjectURL(value);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        const reportName = fileName + this.getLocalDate(Date.now(), 'YYYYMMDD_hhmmA') + '.xlsx';
        link.setAttribute('download', reportName);
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private getLocalDate(inputDate: any, format: string): string {
        const utcDate = moment.utc(inputDate);
        const localDate = utcDate.local().format(format);
        return localDate;
    }
}
